import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import PositionForm from './PositionForm';

const PositionActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const PositionEdit = (props: any) => {
  return (
    <Edit actions={<PositionActions {...props} />} {...props}>
      <PositionForm />
    </Edit>
  );
};

export default PositionEdit;
